/**
 * 共通文言マスター定義
 * 複数画面で使い回すアクション・名詞をここで一元管理する
 */

import type { MasterDictionary } from "./types";

const COMMON = {
    // ── アクション（処理） ──────────────────────────
    SAVE:             { ja: "保存",       en: "Save",           edit_flg: false },
    SAVING:           { ja: "保存中...",   en: "Saving...",      edit_flg: false },
    CANCEL:           { ja: "キャンセル",  en: "Cancel",         edit_flg: false },
    DELETE:           { ja: "削除",       en: "Delete",         edit_flg: false },
    EDIT:             { ja: "編集",       en: "Edit",           edit_flg: false },
    NEW_REGISTRATION: { ja: "新規登録",    en: "New",            edit_flg: false },
    LOADING:          { ja: "読み込み中...", en: "Loading...",    edit_flg: false },

    // ── 名詞（文言） ────────────────────────────
    SETTINGS:         { ja: "設定",           en: "Settings",         edit_flg: false },
    LOGIN:            { ja: "ログイン",        en: "Login",             edit_flg: false },
    LOGOUT:           { ja: "ログアウト",      en: "Logout",            edit_flg: false },
    PASSWORD:         { ja: "パスワード",      en: "Password",          edit_flg: false },
    MONTHLY_SHIFT:    { ja: "シフト表",        en: "Shift Schedule",     edit_flg: false },
    DAILY_SHIFT:      { ja: "ワークスケジュール", en: "Daily Schedule",    edit_flg: false },
    EMPLOYEE:         { ja: "従業員",         en: "Employee",          edit_flg: true },
    TENANT:           { ja: "テナント",       en: "Tenant",           edit_flg: true },
    ORGANIZATION:     { ja: "組織",           en: "Organization",      edit_flg: true },
    STORE:            { ja: "店舗",           en: "Store",             edit_flg: true },
    SHIFT_PATTERN:    { ja: "シフトパターン",   en: "Shift Pattern",     edit_flg: false },
    TASK:             { ja: "作業",           en: "Task",              edit_flg: false },
    DISPLAY:          { ja: "表示",           en: "Display",           edit_flg: false },
    ANALYTICS:        { ja: "分析",           en: "Analytics",         edit_flg: false },
    NOTIFICATIONS:    { ja: "お知らせ",        en: "Notifications",     edit_flg: false },

    REQUIRED:         { ja: "必要",           en: "Required ",        edit_flg: false },
    MAN_HOURS:        { ja: "人時",           en: "Man-Hours",        edit_flg: false },

    // ── メニュー合成用 ─────────────────────────
    HOME:             { ja: "ホーム",           en: "Home",              edit_flg: false },
    WORK_STYLE:       { ja: "働き方",           en: "Work Style",        edit_flg: false },
    SWITCH:           { ja: "切替",             en: "Switch",            edit_flg: false },
    CHANGE:           { ja: "変更",             en: "Change",            edit_flg: false },
    EMAIL:            { ja: "メールアドレス",     en: "Email",             edit_flg: false },
    ACCOUNT:          { ja: "アカウント",        en: "Account",           edit_flg: false },
    ACCOUNT_NAME:     { ja: "アカウント名",       en: "Account Name",      edit_flg: false },
    NOT_IMPLEMENTED:  { ja: "「{{feature}}」未実装", en: "\"{{feature}}\" not implemented", edit_flg: false },
} as const satisfies MasterDictionary;

export default COMMON;
